import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getKnmErpInitialFormValues = (state: IRootState) => state.knmErp.initialFormValues;
